import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a2ad28b03012fdd8cab241638bd6fba3db from "./generated-a55f9167-4eb3-42ea-a073-573c7b070c28.json";

import ae2e0d8967340af4d64f88f26dcefb782b from "./generated-e592eaf4-95f5-4452-828f-775d50db5b93.json";

import ac17054c6775f821616822d371ace7099b from "./generated-f7b34097-4525-4158-aa18-2abd71dd34d9.json";

import a858196af15c6109090da81410c31a3bcb from "./generated-3fb67803-6de4-4bd2-8f10-a81ef011265f.json";

import acfae65dcb324eee07f94feb910d19dc0b from "./generated-215dd569-3496-4351-b0c8-0b909d6dfc72.json";

import a8f9282c8bc65350a88da23bf9f7eb818b from "./generated-ba61d6e8-c0dc-4026-912b-4c98045fbd06.json";

import ae1f1aeb6d13d4a3bdc788dc887afc441b from "./generated-9851133d-796a-44b9-8ff9-af7b2ee58e3e.json";

import aca84e5a4bfe3982f22af7570700c3a30b from "./generated-caf42ddb-6074-4ab9-8897-505d0fb67ad5.json";

import a6ec6ac3c7632c6227ee0c262916fd73eb from "./generated-55ecd7b4-bded-4b50-9329-d271869ae763.json";

import a41879b2612fab5548480cd55ffe75fd3b from "./generated-736cf36e-6d74-47d0-9f60-53caabfb2626.json";

import a80f17f2b64c4e868e6c6d3e45b6ed168b from "./generated-69cf34e7-0216-4144-9a20-8cdcf289d75e.json";

import a13e8b6dc77fbbcf46dba70f49f22f356b from "./generated-e4d17e30-dae3-4ee5-9dce-bfcb3900c320.json";

import a3ccea8396d83456a2ac53645a3d6fe4eb from "./generated-2f1bb396-36cf-4af4-adda-7108157a07e1.json";

import af3d02cee17399aeb26c3fbeabddad41cb from "./generated-7b3f9066-3189-4fdb-a033-24a1293bf727.json";

import a69eba69c8b5238a42720769cc265fb64b from "./generated-d7fee603-84b4-4446-beb6-2a9bc9ba9ee8.json";

import ac82c443f66d09c93f0b305503e43f46fb from "./generated-6c1a703f-80c7-4028-94f5-066fc909d154.json";

import a30927cc7db4acce66919e3d3af40f2c5b from "./generated-eeb0992f-d0e8-45fc-b67b-1d621b7944d0.json";

import a139c6d11f7692d66a7ba91178f54bb56b from "./generated-4943750c-406e-4475-ab7f-acf631925539.json";

import a4b2b782f9b588c8d04ffc0c18cf9643db from "./generated-7ae0c439-0868-4e03-bd4d-ffe721f66b10.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a2ad28b03012fdd8cab241638bd6fba3db);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ae2e0d8967340af4d64f88f26dcefb782b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ac17054c6775f821616822d371ace7099b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a858196af15c6109090da81410c31a3bcb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(acfae65dcb324eee07f94feb910d19dc0b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a8f9282c8bc65350a88da23bf9f7eb818b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ae1f1aeb6d13d4a3bdc788dc887afc441b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(aca84e5a4bfe3982f22af7570700c3a30b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a6ec6ac3c7632c6227ee0c262916fd73eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a41879b2612fab5548480cd55ffe75fd3b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a80f17f2b64c4e868e6c6d3e45b6ed168b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a13e8b6dc77fbbcf46dba70f49f22f356b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a3ccea8396d83456a2ac53645a3d6fe4eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(af3d02cee17399aeb26c3fbeabddad41cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a69eba69c8b5238a42720769cc265fb64b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac82c443f66d09c93f0b305503e43f46fb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a30927cc7db4acce66919e3d3af40f2c5b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a139c6d11f7692d66a7ba91178f54bb56b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a4b2b782f9b588c8d04ffc0c18cf9643db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a30927cc7db4acce66919e3d3af40f2c5b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */